module.exports = __webpack_public_path__ + "img/bassin-a-sec-900-600.c47c0c8e.png";